import React from "react";
import { VideoPlayer } from "@/components/VideoPlayer";

// Thin wrapper kept for its existing call sites (chat media / story archive /
// church detail). Playback now flows through the universal <VideoPlayer>
// (controls mode) — now HLS-capable (Cloudflare + Bunny), poster, ready-fade.
export const PlayableVideo = (props) => <VideoPlayer mode="controls" {...props} />;

export default PlayableVideo;
